import { APP_NAME, IS_PROD } from '../lib/config';

const ENV_SUFFIX = IS_PROD ? 'prod' : 'test';

export const LANGUAGE_KEY = `mezzoforte:${APP_NAME}:language:${ENV_SUFFIX}`;

export const FONT_SIZE_KEY = `mezzoforte:${APP_NAME}:fontsize:${ENV_SUFFIX}`;
